module.exports = __webpack_public_path__ + "static/media/blog-img3.310e697b.jpg";